import { createContext } from "react";

export const PatientData = createContext(null);
export const CprData = createContext(null);
export const FeedPrompt = createContext(null);
